import Column from '@app/components/layout/Column'
import Row from '@app/components/layout/Row'
import {
  regionsTabsQueryParamName,
  regionTabs,
} from '@app/pages/discover/regions/constants'
import { fullName } from '@app/util/helpers'
import { DiscussionCard } from '../../discussions'
import { SectionHeader } from '../../sectionHeader/SectionHeader'
import { useTranslations } from '@i18n/useLanguage'
import useDateFormat from '@app/util/useDateFormat'
import { PostViewModel } from 'functions/app/thread/view-latest'
import { AppearItem, useAppearStyle } from '../blocks/AppearInViewport'

export type ThreadContentSectionType = {
  type: 'thread'
  title: string
  titleLevel?: 'H1' | 'H2' | 'H3' | 'H4'
  items: PostViewModel[]
}

export const ThreadContentSection = ({
  title,
  titleLevel = 'H4',
  items,
}: ThreadContentSectionType) => {
  const t = useTranslations().app

  if (items.length === 0) return null

  return (
    <Column alignItems="stretch" gap={0}>
      <AppearItem staggerIndex={0}>
        <SectionHeader
          title={title}
          titleLevel={titleLevel}
          seeMore={t.common.seeMore}
          toRoute={`?${regionsTabsQueryParamName}=${regionTabs.discussion}`}
        />
      </AppearItem>
      <Row style={{ gap: '1rem' }}>
        {items.map((p, index) => (
          <DiscussionCardItem key={p.id} post={p} staggerIndex={index + 1} />
        ))}
      </Row>
    </Column>
  )
}

const DiscussionCardItem = ({
  post,
  staggerIndex,
}: {
  post: PostViewModel
  staggerIndex: number
}) => {
  const t = useTranslations().app
  const dateFormat = useDateFormat()
  const appearStyle = useAppearStyle(staggerIndex)

  return (
    <DiscussionCard
      authorName={post.author ? fullName(post.author) : t.common.unknown}
      authorAvatar={post.author?.avatar}
      date={post.createdAt ? dateFormat(new Date(post.createdAt)) : ''}
      content={post.content ?? ''}
      likes={post.viewers?.count ?? 0}
      replies={post.replies?.count ?? 0}
      style={{ flex: 1, ...appearStyle }}
    />
  )
}
